import { Routes } from "@angular/router"
import { HomeComponent } from './home/home.component'
import { LoginComponent } from './login/login.component'
import { LicenciamentoBciComponent } from './components/licenciamento-bci/licenciamento-bci.component'

export const ROUTES: Routes = [
    { path: '', component: HomeComponent },
    { path: 'login', component: LoginComponent },
    { path: 'licenciamento-bci', component: LicenciamentoBciComponent }
]
